import React from "react";
import styled from "@emotion/styled";
import { Grid, Container, Typography, Box, useMediaQuery } from "@mui/material";
import SimpleResponsivePicture from "./SimpleResponsivePicture";

import purify from "dompurify";
// import ResponsivePicture from "./ResponsivePicture";
//TODO fix line below image with an explicit height or crop images to fit space exactly. Might have to rethink the layout.
export default function Hero2({ Copy, theme, ...props }) {
  const isPhone = useMediaQuery(theme?.breakpoints?.down("sm"));

  // let HeroImage = imageObj[0]?.attributes;

  // if (isPhone) {
  //   HeroImage = imageObj[1]?.attributes;
  // }
  //TODO should use regex and ignore case
  if (Copy === "<p>our community</p>" && isPhone) {
    Copy = "<p>community</p>";
  }
  return (
    <>
      <Grid
        container
        flexDirection={isPhone ? "column-reverse" : "row"}
        justifyContent={"space-around"}
        alignItems={"center"}
        style={{ position: "relative" }}
      >
        <SimpleResponsivePicture
          imageObj={props?.imageObj}
          sx={{ maxWidth: "100%", height: { xs: 225, sm: "auto" }, width: "100vw" }}
        />
        <TextWrapper dangerouslySetInnerHTML={{ __html: Copy }} />
      </Grid>
    </>
  );
}

const TextWrapper = styled("div")`
  width: 100%;
  position: absolute;
  bottom: 5px;
  left: 0;
  > p {
    margin: 0;
    color: white;
    line-height: normal;
    font-size: clamp(3.9rem, 7.3vw, 7.1875rem);
  }
  ${props => props.theme.breakpoints.up("md")} {
    width: unset;
    position: absolute;
    left: 10%;
  }
`;
